/**
 * DIEUKYDIEU.TV - MEDIA API SERVICE
 * Connects UI to backend multimedia (Video, Audio, Gallery, Playlists) endpoints.
 * Under 300 lines rule compliant.
 */

import { API_CONFIG } from './config.js';
import { apiClient } from './client.js';
import { mockAdapter } from './mock/mock-adapter.js';

export const mediaApi = {
    /**
     * Get media category hierarchy
     */
    async getMediaCategories() {
        if (API_CONFIG.USE_MOCK) {
            return (await mockAdapter.getMediaCategories()).data;
        }

        try {
            const res = await apiClient.get('/media/categories');
            return res.data || res;
        } catch (err) {
            console.warn('[mediaApi] Failed fetching media categories, falling back to mock:', err.message);
            if (API_CONFIG.ENABLE_FALLBACK_ON_ERROR) {
                return (await mockAdapter.getMediaCategories()).data;
            }
            throw err;
        }
    },

    /**
     * Get hero featured media item
     */
    async getFeaturedMedia() {
        if (API_CONFIG.USE_MOCK) {
            return (await mockAdapter.getFeaturedMedia()).data;
        }

        try {
            const res = await apiClient.get('/media/featured');
            return res.data || res;
        } catch (err) {
            console.warn('[mediaApi] Failed fetching featured media, falling back to mock:', err.message);
            if (API_CONFIG.ENABLE_FALLBACK_ON_ERROR) {
                return (await mockAdapter.getFeaturedMedia()).data;
            }
            throw err;
        }
    },

    /**
     * Get media items list by type and subCategory
     */
    async getMediaItems(type = 'all', subCategory = 'all') {
        if (API_CONFIG.USE_MOCK) {
            return (await mockAdapter.getMediaItems(type, subCategory)).data;
        }

        try {
            const res = await apiClient.get('/media/items', { type, subCategory });
            return res.data || res;
        } catch (err) {
            console.warn(`[mediaApi] Failed fetching media items (${type}), falling back to mock:`, err.message);
            if (API_CONFIG.ENABLE_FALLBACK_ON_ERROR) {
                return (await mockAdapter.getMediaItems(type, subCategory)).data;
            }
            throw err;
        }
    },

    /**
     * Get player audio playlist
     */
    async getAudioPlaylist() {
        if (API_CONFIG.USE_MOCK) {
            return (await mockAdapter.getAudioPlaylist()).data;
        }

        try {
            const res = await apiClient.get('/media/playlist');
            return res.data || res;
        } catch (err) {
            console.warn('[mediaApi] Failed fetching audio playlist, falling back to mock:', err.message);
            if (API_CONFIG.ENABLE_FALLBACK_ON_ERROR) {
                return (await mockAdapter.getAudioPlaylist()).data;
            }
            throw err;
        }
    }
};
